import type { RegionCode } from "core/entities";
import { useContext } from "react";
import { RegionContext } from "../context/RegionContextProvider";

export function useRegion(): RegionCode {
  return useContext(RegionContext);
}
